@if (!mocked) { @if (element.data | withLoading | async; as widget) {
<app-mdr-title
    fontSize="16"
    class="dashboard-box-title d-flex m-b-20"
    (mouseenter)="hideDrilldownTitle = false"
    (mouseleave)="hideDrilldownTitle = true"
    [routerLink]="element?.drilldown?.drilldownTitle ? [element?.drilldown?.drilldownTo] : []"
    [state]="mdrDashboardsService.buildDrilldownFilters(element?.drilldown?.drilldownTitleFilters)"
    [ngClass]="element?.drilldown?.drilldownTitle && !widget.error ? 'drilldown-hover-active' : 'no-hover'"
>
    {{ element.title }}
    @if (widget.error) {
    <span class="ds-icon-error_outline fs-25 error-primary m-l-8 line-height-08"></span>
    } @if (element.drilldown?.drilldownTitle && !widget.error) {
    <span
        [hidden]="hideDrilldownTitle"
        class="drilldown-hover-active-icon"
        [ngClass]="'ds-icon-open_link fs-25'"
    ></span>
    }
</app-mdr-title>
<!--        SEMI-EMPTY STATE-->
@if (widget && widget.data?.data.length && !widget.loading && (widget.data?.data.length !== element.no_rows ?
fillIncompleteDataSource(widget.data?.data, element.columns, element.no_rows) : ''); as semiEmptyDataSource) {
<table
    [hidden]="true"
    mat-table
    [id]="element.id"
    [dataSource]="semiEmptyDataSource"
    class="dashboard-table semi-empty-table {{ parentClassName }}"
    [ngStyle]="{ 'table-layout': !isChart ? 'fixed' : '' }"
    [ngClass]="!bottomBorder ? 'no-border' : ''"
>
    @for (col of hiddenColumns; track col) {
    <ng-container [matColumnDef]="col">
        <td
            [hidden]="true"
            mat-cell
            *matCellDef="let element"
        >
            <b>{{ element.col }} </b>
        </td>
    </ng-container>
    }
    <ng-container matColumnDef="name">
        <td
            #tooltip="matTooltip"
            [matTooltip]="item.name"
            matTooltipClass="mat-tooltip-custom"
            [matTooltipDisabled]="disableTooltip"
            (mouseover)="checkInputClientVisibility($event, tooltip, '.mat-cell')"
            mat-cell
            *matCellDef="let item; let i = index"
            [ngStyle]="{ width: getColumnWidth('name') }"
            class="table-row--name"
        >
            <div class="d-flex table-row--name {{ parentClassName }}">
                @if (item.logo) {
                <span [ngClass]="'ds-icon-' + item.logo.slice(0, 3).toLowerCase() + ' fs-20'"></span>
                }
                <span
                    [ngClass]="bulletType + '-bullet-legend m-t-5'"
                    [style.background]="item.color"
                ></span>
                <span class="text-ellipsis">
                    {{ item.name }}
                </span>
                @if (allowDocumentDownload(element, item)) {
                <span [ngClass]="element?.drilldown?.hover_icon + ' download-icon visibility-hidden fs-20 m-l-5'"> </span>
                } @if (element && downloadingItems[i] && allowDocumentDownload(element, item)) {
                <mat-spinner
                    class="spinner-widget"
                    [diameter]="15"
                    [strokeWidth]="2"
                ></mat-spinner>
                }
            </div>
        </td>
    </ng-container>
    @for (col of basicColumns; track col) {
    <ng-container [matColumnDef]="col.name">
        <td
            #tooltip="matTooltip"
            [matTooltip]="
                col.name === 'date' && item[col.name] !== '...'
                    ? (item[col.name] | amFromUtc | amLocal | amDateFormat : 'DD MMM YYYY, HH:mm')
                    : item[col.name]
            "
            matTooltipClass="mat-tooltip-custom"
            [matTooltipDisabled]="disableTooltip"
            (mouseover)="checkInputClientVisibility($event, tooltip, '.mat-cell')"
            class="wrap-last-column"
            mat-cell
            *matCellDef="let item"
            [ngClass]="className"
            [ngStyle]="{ width: getColumnWidth(col.name) }"
        >
            {{
                col.name === 'date' && item[col.name] !== '...'
                    ? (item[col.name] | amFromUtc | amLocal | amDateFormat : 'DD MMM YYYY, HH:mm')
                    : item[col.name]
            }}
        </td>
    </ng-container>
    }
    <ng-container matColumnDef="progress">
        <td
            mat-cell
            *matCellDef="let element; let i = index"
        >
            <div class="progress-component">
                <app-mdr-progress-bar
                    [value]="getProcessedValue(element, widget.data?.data)"
                    [maxValue]="calculateProgressBarMaxValue(widget.data?.data, i)"
                >
                </app-mdr-progress-bar>
                <div class="value">{{ element.value ? element.value : element.percent }}</div>
            </div>
        </td>
    </ng-container>
    <ng-container matColumnDef="value">
        <td
            [ngStyle]="{ width: getColumnWidth('value') }"
            [hidden]="displayedColumns.includes('progress')"
            mat-cell
            *matCellDef="let element"
            #tooltip="matTooltip"
            [matTooltip]="element.value"
            matTooltipClass="mat-tooltip-custom"
            [matTooltipDisabled]="disableTooltip"
            (mouseover)="checkInputClientVisibility($event, tooltip, '.mat-cell')"
        >
            <b> {{ element.value }} </b>
        </td>
    </ng-container>
    <ng-container matColumnDef="percent">
        <td
            class="width-p-20"
            [hidden]="displayedColumns.includes('progress')"
            mat-cell
            *matCellDef="let element"
        >
            <b> {{ element.percent }} </b>
        </td>
    </ng-container>
    <ng-container matColumnDef="checked">
        <td
            class="width-p-20"
            mat-cell
            *matCellDef="let element"
        >
            @if (element.checked) {
            <mat-icon>done</mat-icon>
            }
        </td>
    </ng-container>
    <ng-container matColumnDef="status">
        <td
            mat-cell
            *matCellDef="let element"
        >
            <mat-chip-listbox>
                <mat-chip disableRipple>
                    <span>{{ element.status }}</span>
                </mat-chip>
            </mat-chip-listbox>
        </td>
    </ng-container>
    @if (!element?.drilldown?.allowExternalUrl && !element?.drilldown?.allowDownloadData) {
    <tr
        mat-row
        *matRowDef="let row; columns: displayedColumns"
        [routerLink]="mdrDashboardsService.buildDrilldownRouterLink(element?.drilldown?.drilldownTo, row)"
        [state]="mdrDashboardsService.buildDrilldownFilters(element?.drilldown?.drilldownFilters, row)"
        [ngClass]="
            mdrDashboardsService.isHoverable(element, row)
                ? 'drilldown-hover-active ' + element?.drilldown?.hover_color + '-hover-color'
                : 'no-hover'
        "
    ></tr>
    } @if (element?.drilldown?.allowExternalUrl) {
    <tr
        mat-row
        *matRowDef="let row; columns: displayedColumns"
        (click)="mdrDashboardsService.navigateToExternalUrl(element?.drilldown?.externalUrl)"
        [ngClass]="
            mdrDashboardsService.isHoverable(element, row)
                ? 'drilldown-hover-active ' + element?.drilldown?.hover_color + '-hover-color'
                : 'no-hover'
        "
    ></tr>
    } @if (element?.drilldown?.allowDownloadData) {
    <tr
        mat-row
        *matRowDef="let row; let i = index; columns: displayedColumns"
        (mousedown)="downloadDoc(dataSource, element?.drilldown?.externalData, i, $event)"
        [ngClass]="
            mdrDashboardsService.isHoverable(element, row, i)
                ? 'drilldown-hover-active ' + element?.drilldown?.hover_color + '-hover-color'
                : 'no-hover'
        "
    ></tr>
    }
</table>
}
<!--        NORMAL STATE-->
@if (widget.data?.data.length && !widget.loading && widget.data?.data.length === element.no_rows) {
<table
    mat-table
    [id]="element.id"
    [dataSource]="widget.data?.data"
    class="dashboard-table normal-table {{ parentClassName }}"
    [ngStyle]="{ 'table-layout': !isChart ? 'fixed' : '' }"
    [ngClass]="!bottomBorder ? 'no-border' : ''"
>
    @for (col of hiddenColumns; track col) {
    <ng-container [matColumnDef]="col">
        <td
            [hidden]="true"
            mat-cell
            *matCellDef="let element"
        >
            <b> {{ element.col }} </b>
        </td>
    </ng-container>
    }
    <ng-container matColumnDef="name">
        <td
            mat-cell
            *matCellDef="let item; let i = index"
            [ngStyle]="{ width: getColumnWidth('name') }"
            class="table-row--name"
        >
            <div
                class="d-flex {{ parentClassName }}"
                #tooltip="matTooltip"
                [matTooltip]="item.name"
                matTooltipClass="mat-tooltip-custom"
                [matTooltipDisabled]="disableTooltip"
                (mouseover)="checkInputClientVisibility($event, tooltip, 'span')"
            >
                @if (item.logo) {
                <span [ngClass]="'ds-icon-' + item.logo.slice(0, 3).toLowerCase() + ' fs-20'"></span>
                } @if (item.logo) {
                <span
                    [ngClass]="bulletType + '-bullet-legend m-t-5'"
                    [style.background]="item.color"
                ></span>
                }
                <span class="text-ellipsis">
                    {{ item.name }}
                </span>
                @if (allowDocumentDownload(element, item)) {
                <span [ngClass]="element?.drilldown?.hover_icon + ' download-icon visibility-hidden fs-20 m-l-5'"> </span>
                } @if (element && downloadingItems[i] && allowDocumentDownload(element, item)) {
                <mat-spinner
                    class="spinner-widget"
                    [diameter]="15"
                    [strokeWidth]="2"
                ></mat-spinner>
                }
            </div>
        </td>
    </ng-container>
    @for (col of basicColumns; track col) {
    <ng-container [matColumnDef]="col.name">
        <td
            #tooltip="matTooltip"
            [matTooltip]="
                col.name === 'date' && item[col.name] !== '...'
                    ? (item[col.name] | amFromUtc | amLocal | amDateFormat : 'DD MMM YYYY, HH:mm')
                    : item[col.name]
            "
            matTooltipClass="mat-tooltip-custom"
            [matTooltipDisabled]="disableTooltip"
            [ngClass]="className"
            (mouseover)="checkInputClientVisibility($event, tooltip, '.mat-cell')"
            class="wrap-last-column"
            mat-cell
            *matCellDef="let item"
            [ngStyle]="{ width: getColumnWidth(col.name) }"
        >
            {{
                col.name === 'date' && item[col.name] !== '...'
                    ? (item[col.name] | amFromUtc | amLocal | amDateFormat : 'DD MMM YYYY, HH:mm')
                    : item[col.name]
            }}
        </td>
    </ng-container>
    }
    <ng-container matColumnDef="progress">
        <td
            mat-cell
            *matCellDef="let element; let i = index"
        >
            <div class="progress-component">
                <app-mdr-progress-bar
                    [value]="getProcessedValue(element, widget.data?.data)"
                    [maxValue]="calculateProgressBarMaxValue(widget.data?.data, i)"
                >
                </app-mdr-progress-bar>
                <div class="value">{{ element.value ? element.value : element.percent }}</div>
            </div>
        </td>
    </ng-container>
    <ng-container matColumnDef="value">
        <td
            [ngStyle]="{ width: getColumnWidth('value') }"
            [hidden]="displayedColumns.includes('progress')"
            mat-cell
            *matCellDef="let element"
            #tooltip="matTooltip"
            [matTooltip]="element.value"
            matTooltipClass="mat-tooltip-custom"
            [matTooltipDisabled]="disableTooltip"
            (mouseover)="checkInputClientVisibility($event, tooltip, '.mat-cell')"
        >
            <b> {{ element.value }} </b>
        </td>
    </ng-container>
    <ng-container matColumnDef="percent">
        <td
            class="width-p-20"
            [hidden]="displayedColumns.includes('progress')"
            mat-cell
            *matCellDef="let element"
        >
            <b> {{ element.percent }} </b>
        </td>
    </ng-container>
    <ng-container matColumnDef="checked">
        <td
            class="width-p-20"
            mat-cell
            *matCellDef="let element"
        >
            @if (element.checked) {
            <mat-icon>done</mat-icon>
            }
        </td>
    </ng-container>
    <ng-container matColumnDef="status">
        <td
            mat-cell
            *matCellDef="let element"
        >
            <mat-chip-listbox>
                <mat-chip disableRipple>
                    <span>{{ element.status }}</span>
                </mat-chip>
            </mat-chip-listbox>
        </td>
    </ng-container>
    @if (!element?.drilldown?.allowExternalUrl && !element?.drilldown?.allowDownloadData) {
    <tr
        mat-row
        *matRowDef="let row; columns: displayedColumns"
        [routerLink]="mdrDashboardsService.buildDrilldownRouterLink(element?.drilldown?.drilldownTo, row)"
        [state]="mdrDashboardsService.buildDrilldownFilters(element?.drilldown?.drilldownFilters, row)"
        [ngClass]="
            mdrDashboardsService.isHoverable(element, row)
                ? 'drilldown-hover-active ' + element?.drilldown?.hover_color + '-hover-color'
                : 'no-hover'
        "
    ></tr>
    } @if (element?.drilldown?.allowExternalUrl) {
    <tr
        mat-row
        *matRowDef="let row; columns: displayedColumns"
        (click)="mdrDashboardsService.navigateToExternalUrl(element?.drilldown?.externalUrl)"
        [ngClass]="
            mdrDashboardsService.isHoverable(element, row)
                ? 'drilldown-hover-active ' + element?.drilldown?.hover_color + '-hover-color'
                : 'no-hover'
        "
    ></tr>
    } @if (element?.drilldown?.allowDownloadData) {
    <tr
        mat-row
        *matRowDef="let row; let i = index; columns: displayedColumns"
        (mousedown)="downloadDoc(dataSource, element?.drilldown?.externalData, i, $event)"
        [ngClass]="
            mdrDashboardsService.isHoverable(element, row, i)
                ? 'drilldown-hover-active ' + element?.drilldown?.hover_color + '-hover-color'
                : 'no-hover'
        "
    ></tr>
    }
</table>
}
<!--        EMPTY STATE-->
@if ((!widget.data?.data.length || widget.error) && !widget.loading) {
<table
    mat-table
    [id]="element.id"
    [dataSource]="emptyDataSource"
    class="dashboard-table empty_state {{ parentClassName }}"
    [ngStyle]="{ 'table-layout': !isChart ? 'fixed' : '' }"
    [ngClass]="!bottomBorder ? 'no-border' : ''"
>
    @for (col of hiddenColumns; track col) {
    <ng-container [matColumnDef]="col">
        <td
            [hidden]="true"
            mat-cell
            *matCellDef="let element"
        >
            <b> {{ element.col }} </b>
        </td>
    </ng-container>
    }
    <ng-container matColumnDef="name">
        <td
            mat-cell
            *matCellDef="let item; let i = index"
            class="table-row--name"
        >
            <div class="d-flex {{ parentClassName }}">
                @if (item.logo) {
                <span
                    [ngClass]="'empty-round-bullet-legend m-t-5'"
                    [style.background]="'#E2E2E2'"
                ></span>
                }
                <span
                    [ngClass]="bulletType + '-bullet-legend m-t-5'"
                    [style.background]="item.color"
                ></span>
                <span class="text-ellipsis">
                    {{ item.name }}
                </span>
                @if (allowDocumentDownload(element, item)) {
                <span [ngClass]="element?.drilldown?.hover_icon + ' download-icon visibility-hidden fs-20 m-l-5'"> </span>
                } @if (element && downloadingItems[i] && allowDocumentDownload(element, item)) {
                <mat-spinner
                    class="spinner-widget"
                    [diameter]="15"
                    [strokeWidth]="2"
                ></mat-spinner>
                }
            </div>
        </td>
    </ng-container>
    @for (col of basicColumns; track col) {
    <ng-container [matColumnDef]="col.name">
        <td
            [ngClass]="className"
            mat-cell
            *matCellDef="let element"
        >
            {{ element[col.name] }}
        </td>
    </ng-container>
    }
    <ng-container matColumnDef="progress">
        <td
            mat-cell
            *matCellDef="let element; let i = index"
        >
            <div class="progress-component">
                <app-mdr-progress-bar
                    [value]="getProcessedValue(element, widget.data?.data)"
                    [maxValue]="calculateProgressBarMaxValue(widget.data?.data, i)"
                >
                </app-mdr-progress-bar>
                <div class="value">{{ element.value ? element.value : element.percent }}</div>
            </div>
        </td>
    </ng-container>
    <ng-container matColumnDef="value">
        <td
            class="width-p-20"
            [hidden]="displayedColumns.includes('progress')"
            mat-cell
            *matCellDef="let element"
        >
            <b>{{ element.value }} </b>
        </td>
    </ng-container>
    <ng-container matColumnDef="percent">
        <td
            class="width-p-20"
            [hidden]="displayedColumns.includes('progress')"
            mat-cell
            *matCellDef="let element"
        >
            <b> {{ element.percent }} </b>
        </td>
    </ng-container>
    <ng-container matColumnDef="checked">
        <td
            class="width-p-20"
            mat-cell
            *matCellDef="let element"
        >
            @if (element.checked) {
            <mat-icon>done</mat-icon>
            }
        </td>
    </ng-container>
    <ng-container matColumnDef="status">
        <td
            mat-cell
            *matCellDef="let element"
        >
            <mat-chip-listbox>
                <mat-chip disableRipple>
                    <span>{{ element.status }}</span>
                </mat-chip>
            </mat-chip-listbox>
        </td>
    </ng-container>
    <tr
        mat-row
        *matRowDef="let row; columns: displayedColumns"
        class="no-hover"
    ></tr>
</table>
} @if (widget.loading) {
<app-mdr-loader
    [ngClass]="widget.loading ? 'widget-empty' : 'widget-loading'"
    class="center-loader"
    [rows]="10"
    [columns]="1"
></app-mdr-loader>
} } } @if (mocked) {
<table
    mat-table
    [dataSource]="dataSource"
    class="dashboard-table mocked {{ parentClassName }}"
    [ngClass]="!bottomBorder ? 'no-border' : ''"
>
    <ng-container>
        @for (col of hiddenColumns; track col) {
        <ng-container [matColumnDef]="col">
            <td
                [hidden]="true"
                mat-cell
                *matCellDef="let element"
            >
                <b> {{ element.col }} </b>
            </td>
        </ng-container>
        }
        <ng-container matColumnDef="name">
            <td
                mat-cell
                *matCellDef="let item; let i = index"
                class="table-row--name"
            >
                <div class="d-flex {{ parentClassName }}">
                    @if (item.logo) {
                    <span [ngClass]="'ds-icon-' + item.logo + ' fs-20'"></span>
                    }
                    <span
                        [ngClass]="bulletType + '-bullet-legend m-t-5'"
                        [style.background]="item.color"
                    ></span>
                    <span class="text-ellipsis">
                        {{ item.name }}
                    </span>
                    @if (allowDocumentDownload(element, item)) {
                    <span [ngClass]="element?.drilldown?.hover_icon + ' download-icon visibility-hidden fs-20 m-l-5'"> </span>
                    } @if (element && downloadingItems[i] && allowDocumentDownload(element, item)) {
                    <mat-spinner
                        class="spinner-widget"
                        [diameter]="15"
                        [strokeWidth]="2"
                    ></mat-spinner>
                    }
                </div>
            </td>
        </ng-container>
        @for (col of basicColumns; track col) {
        <ng-container [matColumnDef]="col.name">
            <td
                [ngClass]="className"
                mat-cell
                *matCellDef="let element"
            >
                {{ element[col.name] }}
            </td>
        </ng-container>
        }
        <ng-container matColumnDef="progress">
            <td
                mat-cell
                *matCellDef="let element; let i = index"
            >
                <div class="progress-component">
                    <app-mdr-progress-bar
                        [value]="element.value ? element.value : element.percent.replace('%', '')"
                        [maxValue]="calculateProgressBarMaxValue(element, i)"
                    >
                    </app-mdr-progress-bar>
                    <div class="value">{{ element.value ? element.value : element.percent }}</div>
                </div>
            </td>
        </ng-container>
        <ng-container matColumnDef="value">
            <td
                [hidden]="displayedColumns.includes('progress')"
                mat-cell
                *matCellDef="let element"
            >
                <b>{{ element.value }} </b>
            </td>
        </ng-container>
        <ng-container matColumnDef="percent">
            <td
                [hidden]="displayedColumns.includes('progress')"
                mat-cell
                *matCellDef="let element"
            >
                <b> {{ element.percent }} </b>
            </td>
        </ng-container>
        <ng-container matColumnDef="checked">
            <td
                class="width-p-20"
                mat-cell
                *matCellDef="let element"
            >
                @if (element.checked) {
                <mat-icon>done</mat-icon>
                }
            </td>
        </ng-container>
        <ng-container matColumnDef="status">
            <td
                mat-cell
                *matCellDef="let element; let i = index"
            >
                <mat-chip disableRipple>
                    <span>{{ element.status }}</span>
                </mat-chip>
            </td>
        </ng-container>
    </ng-container>
    @if (!element?.drilldown?.allowExternalUrl && !element?.drilldown?.allowDownloadData) {
    <tr
        mat-row
        *matRowDef="let row; columns: displayedColumns"
        [routerLink]="mdrDashboardsService.buildDrilldownRouterLink(element?.drilldown?.drilldownTo, row)"
        [state]="mdrDashboardsService.buildDrilldownFilters(element?.drilldown?.drilldownFilters, row)"
        [ngClass]="
            mdrDashboardsService.isHoverable(element, row)
                ? 'drilldown-hover-active ' + element?.drilldown?.hover_color + '-hover-color'
                : 'no-hover'
        "
        [ngStyle]="{ color: element?.drilldown?.hover_color }"
    ></tr>
    } @if (element?.drilldown?.allowExternalUrl) {
    <tr
        mat-row
        *matRowDef="let row; columns: displayedColumns"
        (click)="mdrDashboardsService.navigateToExternalUrl(element?.drilldown?.externalUrl)"
        [ngClass]="
            mdrDashboardsService.isHoverable(element, row)
                ? 'drilldown-hover-active ' + element?.drilldown?.hover_color + '-hover-color'
                : 'no-hover'
        "
    ></tr>
    } @if (element?.drilldown?.allowDownloadData) {
    <tr
        mat-row
        *matRowDef="let row; let i = index; columns: displayedColumns"
        (mousedown)="downloadDoc(dataSource, element?.drilldown?.externalData, i, $event)"
        [ngClass]="
            mdrDashboardsService.isHoverable(element, row, i)
                ? 'drilldown-hover-active ' + element?.drilldown?.hover_color + '-hover-color'
                : 'no-hover'
        "
    ></tr>
    }
</table>
}
